import { FileCheck2 } from "lucide-react";

const manifest = {
  key: "subscription_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: FileCheck2,
  names: {
    plan: {
      en: "Subscription Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643\u0627\u062a",
    },
    dashboard: {
      en: "Subscription Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0627\u0634\u062a\u0631\u0627\u0643\u0627\u062a",
    },
  },
  defaultPath: "/subscription-management",
  matchers: [/^\/subscription-management(?:\/|$)/, /^\/upgrade(?:\/|$)/],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__subscription_management__",
      children: [
        {
          label:
            t("menu_current_subscription_features") ||
            "Current Subscription Features",
          path: "/subscription-management?tab=features",
        },
        {
          label: t("menu_upgrade_subscription") || "Upgrade Subscription",
          path: "/upgrade",
        },
      ],
    },
  ],
};

export default manifest;
